<template>
  <b-modal :active.sync="isModalActive" @after-leave="hide()" scroll="keep" :can-cancel="canCancel">
    <div class="p-4 bg-white border rounded shadow-lg border-blue-light">

      <header v-if="!editorPDF" class="w-full text-xl font-semibold uppercase text-blue-light text-center">
        {{$t('validate_task')}}
      </header>
      <header v-else class="w-full text-xl font-semibold text-blue-light cursor-pointer">
        <span @click="editorPDF=false">&lt;&lt; {{$t('close_editor_without_saving')}}</span>
      </header>

      <div v-if="!editorPDF">

            <div v-if="form.isLastGroup && (task.status == 5 && task.conditionals)" class="w-full flex flex-col items-center">


              <!-- Task name -->
              <div class="flex flex-row items-center mt-2">
                <div class="font-semibold text-gray-500">{{ task.name }}</div>
              </div>

              <!-- Conditionals -->
              <div v-if="isLoading" class="my-4 text-center">
                <scale-loader />
              </div>
              <div v-else class="flex flex-col items-center mt-2">
                <div class="text-xl"><b>{{ conditionals.question }}</b></div>

                <div class="flex flex-row justify-around w-48 mt-2">

                  <button
                    v-for="(action, key, index) in conditionals.actions"
                    :key="index"
                    :class="action.button.class"
                    type="button"
                    :disabled="isLoading"
                    @click="conditionalAction(action.type, action.data, conditionals.question, action.button.label)">{{ action.button.label }}</button>

                </div>
              </div>

            </div>



            <div v-else class="w-full">
              <form @submit.prevent="submitForm" class="w-full">
                <div>

                  <div class="flex flex-row items-center mt-4">
                    <!-- <div class="w-3 h-3 mr-1 rounded-full bg-green"></div> -->
                    <div class="font-semibold text-black">{{ task.name }}</div>
                  </div>

                  <div class="w-full pb-3 mt-4" >
                    <div class="text-xs font-medium text-blue">{{ $t("observations") }}</div>
                    <b-input
                      v-model="form.observation"
                      name="observation"
                      :placeholder="$t('observations')"
                      class="w-full"
                      maxlength="2000"
                      type="textarea"
                    ></b-input>

                    <div class="flex justify-center w-full pb-3 mt-4 gap-1" >
                      <!-- SIEMPRE DESPLEGADO <div class="flex flex-col w-1/4">
                        <button class="btn btn-blue" type="button" :disabled="isLoading" @click="toggleUpload()">
                          <i class="fas fa-paperclip"></i>&nbsp;
                          Adjuntar doc
                        </button>
                      </div> -->

                      <div class="flex flex-col w-1/4">
                        <button class="btn btn-red" type="button" @click="openCollapse = !openCollapse" :disabled="isLoading || fileEditing || form.isFirstGroup">
                          {{$t('reject')}}
                        </button>
                      </div>
                      <div class="flex flex-col w-1/4">
                        <button class="btn btn-blue" type="button" @click="submitStatus(7)" :disabled="isLoading || fileEditing">
                          {{$t('update_without_validating')}}
                        </button>
                      </div>
                      <div class="flex flex-col w-1/4">
                        <button class="btn bg-green-light border-green-light text-white hover:bg-green-lighter hover:border-green-lighter" type="button" @click="toggleRejectPartial" :disabled="isLoading || fileEditing">
                          {{$t('validate_with_comment')}}
                        </button>
                      </div>
                      <div class="flex flex-col w-1/4">
                        <button class="btn btn-green" type="button" @click="submitStatus(3)" :disabled="isLoading || fileEditing">
                          {{$t('validate')}} <span v-if="form.isLastGroup">*</span>
                        </button>
                      </div>
                    </div>

                    <b-collapse
                        animation="slide"
                        v-model="openCollapse">
                        <div class="w-full border text-center mt-4 pt-4 rounded"
                             :class="rejectPartial ? 'bg-green-lightest border-green-light' : 'bg-red-lightest border-red-light'">
                            <b class="">{{$t('select_reject_group')}}</b> <br/>
                            <span class="inline-flex mt-5" v-for="(group) in task.validation_groups" :key="group.id">
                                <div @click="form.selectedGroup = group.order_column" v-if="group.status != 0 && group.id != task.current_group.id" class="h-10 p-2 mr-1 font-bold text-xs text-center text-white btn"
                                    :class="form.selectedGroup == group.order_column ? 'btn-blue': 'btn-gray'">
                                        {{ group.group.name }}
                                </div>
                            </span> <br/>
                            <div class="inline-flex mb-3 mt-5" v-if="preserveValidatedGroups">
                              <b-checkbox v-model="form.isPreservingGroups" :disabled="form.isFirstGroup || form.selectedGroup == null">
                                {{$t('preserve_validated_groups')}}
                              </b-checkbox>
                            </div>
                            <br/>
                            <div class="inline-flex mb-3 mt-5">
                              <button
                                :class="rejectPartial ? 'btn bg-green' : 'btn btn-red'"
                                type="button"
                                @click="rejectPartial ? submitStatus(8) : submitStatus(4)"
                                :disabled="isLoading || fileEditing || form.isFirstGroup || form.selectedGroup == null ">
                                {{ rejectPartial ? $t('validate') : $t('confirm_reject') }} <br>
                              </button>
                            </div>
                        </div>
                    </b-collapse>


                    <div class="w-full pb-3 mt-4" v-if="!canCancel">
                      <div class="text-red-700 px-4 py-3 rounded relative" style="border: 1px solid rgb(250, 204, 21); border-radius: 6px; padding: 0.25em; background-color: rgb(254, 248, 195);" role="alert">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <strong class="font-bold">{{$t('processing_request')}}</strong>
                        <span class="block sm:inline">{{$t('processing_request_info')}}</span>
                      </div>
                    </div>

                    <div class="text-right text-xs" v-if="form.isLastGroup">
                      * {{$t('validate_document_info')}}
                    </div>

                    <div v-html="$t('pending_document_confirm', [`<i class='fas fa-file-upload'></i>`])" class="text-right text-xs text-red" v-if="fileEditing">
                    </div>

                  </div>

                  <div class="w-full pb-3 mt-4" v-if="showUpload">

                    <!-- DOCUMENTOS DE PROYECTO. PLANTILLAS tambien solo si es cloneDocs true-->
                    <div v-if="task.documentsSelectables && cloneDocs">
                      <div class="text-blue font-bold">{{ $t('templates') }} <b>({{ task.documentsSelectables.length }})</b></div>
                      <div v-for="docTemplate in task.documentsSelectables" :key="'doc_selec_'+docTemplate.document_id">
                        <div class="border border-dashed border-blue rounded p-1 mb-1 flex" style="">
                          <span class="mr-auto text-blue">{{ docTemplate.name }}</span>
                          <span class="ml-auto flex items-center">
                            <!-- input number para cantidad de documentos a clonar -->
                            <b-input
                              v-if="cloneDocs"
                              type="number"
                              :value="cloneDocsQuantity[docTemplate.document_id] || 0"
                              @input="val => $set(cloneDocsQuantity, docTemplate.document_id, Number(val))"
                              style="width: 45px; display: inline-block; margin-right: 6px;"
                              size="is-small"
                            ></b-input>
                            <b-tooltip v-if="cloneDocs"
                              :label="$t('clone_docs')" position="is-left" :multilined="false">
                              <i class="fas fa-clone text-blue cursor-pointer mr-1" @click="cloneDoc(docTemplate)"></i>
                            </b-tooltip>
                            <b-tooltip :label="$t('download')" position="is-left" :multilined="false">
                              <i class="fas fa-file-arrow-down text-blue cursor-pointer mr-1" @click="downloadDoc(docTemplate)"></i>
                            </b-tooltip>
                            <b-tooltip :label="$t('upload_document_project')" position="is-left" :multilined="false">
                              <i class="fas fa-file-import text-blue cursor-pointer" @click="editPDF(docTemplate)"></i>
                            </b-tooltip>
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- SELECTOR DE DOCUMENTOS DE ACTIVIDAD (solo Rejas project)-->
                    <div class="mt-4" v-if="isRejasProject && form.isFirstGroup">
                      <div class="text-blue font-bold">{{ $t('document_manager') }}</div>
                      <div v-if="isLoadingActivityDocs" class="my-2 text-center">
                        <scale-loader />
                      </div>
                      <div v-else class="flex items-center gap-1 mt-1">
                        <b-select v-model="selectedActivityDoc" :placeholder="$t('select_file')" class="w-full" expanded>
                          <option value=""></option>
                          <option v-for="doc in activityDocuments" :key="doc.document_id" :value="doc">
                            {{ doc.original_filename || doc.name }}
                          </option>
                        </b-select>
                      </div>
                    </div>

                    <!-- DOCS YA SUBIDOS -->
                    <div class="font-medium text-blue mt-8">{{ $t('uploaded_documents') }} <b>({{ oldFiles.length }})</b></div>
                    <div v-for="(oldFile, index) in oldFiles" :key="'old_' + index" style="border: 1px solid #b5b5b5; border-radius: 6px;padding: 0.25em;margin-bottom:2px;">
                      <span class="text-xs font-bold">{{ oldFile.name }}</span>
                      <span v-if="differentNames(oldFile.name, oldFile.name2)"><br>{{ oldFile.name2 }}</span>

                      <div class="py-1">
                        <span class="border border-blue border-dashed rounded p-1 cursor-pointer text-white hover:bg-blue"
                          @click="uploadVersion(oldFile)" style="background-color: #63b3ed;">
                          {{$t('upload_local_version')}} <i class="fas fa-file-medical"></i>
                        </span>
                        <span class="border border-blue border-dashed rounded p-1 cursor-pointer text-white hover:bg-blue"
                          @click="openOnlineEditor(oldFile, oldFile.document_id)" style="background-color: #63b3ed;">
                          {{$t('upload_online_version')}} <i class="fas fa-pen"></i>
                        </span>
                      </div>
                    </div>


                    <!-- DOCS NUEVOS PENDIENTES DE SUBIR -->
                    <div class="font-medium text-blue mt-8">{{$t('pending_document_upload')}} <b>({{ newFiles.length }})</b></div>
                    <div v-for="(newFile, index) in newFiles" :key="'new_' + index" style="border: 1px solid #b5b5b5; border-radius: 6px;padding: 0.25em;background-color: #e1fabe;">
                      <span class="text-xs font-bold" v-if="newFile.desc_name">{{ newFile.desc_name }}</span>
                      <span class="text-xs font-bold" v-else>{{ newFile.name }}</span>
                      <br>
                      <div class="flex items-center">
                        <!-- Modo edición: mostrar input -->
                        <b-input
                          v-if="editingFileNameIndex === index"
                          v-model="editingFileNameValue"
                          @keyup.enter="saveFileName(index)"
                          @keyup.esc="cancelEditFileName()"
                          size="is-small"
                          class="text-xs"
                          style="flex: 1; margin-right: 4px;"
                          ref="fileNameInput"
                        ></b-input>
                        <!-- Modo visualización: mostrar custom_name -->
                        <span v-else class="text-xs" style="flex: 1;">
                          {{ newFile.custom_name }}
                        </span>
                        <!-- Icono de lápiz para editar -->
                        <b-tooltip v-if="editingFileNameIndex !== index" :label="$t('edit')" position="is-top" :multilined="false">
                          <i class="fas fa-pencil-alt text-blue cursor-pointer mr-1" @click="editFileName(index)"></i>
                        </b-tooltip>
                        <!-- Iconos de guardar/cancelar cuando está editando -->
                        <span v-if="editingFileNameIndex === index" class="ml-1">
                          <b-tooltip :label="$t('save') || 'Guardar'" position="is-top" :multilined="false">
                            <i class="fas fa-check text-green cursor-pointer mr-1" @click="saveFileName(index)"></i>
                          </b-tooltip>
                          <b-tooltip :label="$t('cancel') || 'Cancelar'" position="is-top" :multilined="false">
                            <i class="fas fa-times text-red cursor-pointer" @click="cancelEditFileName()"></i>
                          </b-tooltip>
                        </span>
                      </div>
                      <b-tooltip :label="$t('delete')" position="is-top" :multilined="false">
                        <i class="fas fa-trash-alt" @click="removeNewFile(index)"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('file_saved_validate_reject')" position="is-top" :multilined="false">
                        <i class="fas fa-exclamation text-blue"></i>
                      </b-tooltip>
                    </div>

                    <!-- DOCUMENTO ACTUAL MODIFICANDO... -->
                    <div v-if="file.size > 0" class="font-medium text-blue">{{$t('current_document')}}</div>
                    <div v-if="file.size > 0" style="border: 1px solid #b5b5b5; border-radius: 6px;padding: 0.25em;background-color: #f9eecd;">
                      <span class="text-xs font-bold" v-if="file.desc_name">{{ file.desc_name }}</span>
                      <span class="text-xs font-bold" v-else>{{ file.name }}</span>
                      <br>
                      {{ file.custom_name }}
                      <b-tooltip :label="$t('set_filename')" position="is-top" :multilined="false" >
                        <i class="fas fa-file-signature" @click="toggleCodification()"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('upload')" position="is-top" :multilined="false">
                        <i class="fas fa-file-upload" @click="sendToQueue()"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('delete')" position="is-top" :multilined="false">
                        <i class="fas fa-trash-alt" @click="removeFile()"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('confirm_upload_document')" position="is-top" :multilined="false">
                        <i class="fas fa-exclamation text-red"></i>
                      </b-tooltip>
                    </div>

                    <!-- DOCUMENTO ACTUAL (DE NUEVA VERSION) MODIFICANDO... -->
                    <div v-if="fileVersion.documentId != 0" class="font-medium text-blue">{{$t('current_document')}}</div>
                    <div v-if="fileVersion.documentId != 0" style="border: 1px solid #b5b5b5; border-radius: 6px;padding: 0.25em;background-color: #f9eecd;">
                      <span class="text-xs font-bold" v-if="fileVersion.desc_name">{{ fileVersion.desc_name }}</span>
                      <span class="text-xs font-bold" v-else>{{ fileVersion.name }}</span>
                      <br>
                      {{ fileVersion.custom_name }}
                      <b-tooltip :label="$t('set_filename')" position="is-top" :multilined="false" >
                        <i class="fas fa-file-signature" @click="toggleCodification()"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('upload')" position="is-top" :multilined="false">
                        <i class="fas fa-file-upload" @click="sendToQueue(1)"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('delete')" position="is-top" :multilined="false">
                        <i class="fas fa-trash-alt" @click="removeFile(1)"></i>
                      </b-tooltip>
                      <b-tooltip :label="$t('confirm_upload_document')" position="is-top" :multilined="false">
                        <i class="fas fa-exclamation text-red"></i>
                      </b-tooltip>
                    </div>

                    <div class="w-full pb-3 mt-4" v-if="showCodification">

                      <codification-lean v-if="project.codification_form && project.codification_form.startsWith('lean')"
                        :form="form"
                        :prefixCode="project.codification_form == 'lean2' || project.codification_form == 'lean3'
                          ? validableParentCode
                          : ''"
                        @generatedCodename="(obj) => applyFileName(obj)"/>

                      <codification-dragados v-if="project.codification_form=='dragados'"
                        :form="form" :is-new-file="!!this.file.size"
                        :version-file-name="this.fileVersion ? this.fileVersion.custom_name : ''"
                        @generatedCodename="(obj) => applyFileName(obj)"/>

                      <codification-rejas v-if="project.codification_form=='rejas'"
                        :form="form" :is-new-file="!!this.file.size"
                        :version-file-name="this.fileVersion ? this.fileVersion.custom_name : ''"
                        @generatedCodename="(obj) => applyFileName(obj)"/>

                      <codification-default v-if="!project.codification_form || project.codification_form === null"
                        :is-new-file="!!this.file.size"
                        :version-file-name-new="this.fileVersion ? this.fileVersion.name : ''"
                        :version-file-name-custom="this.fileVersion ? this.fileVersion.custom_name : ''"
                        :version-file-name-desc="this.fileVersion ? this.fileVersion.desc_name : ''"
                        @generatedCodename="(obj) => applyFileName(obj)"/>

                    </div>

                    <b-field v-if="emptyFile() && company.alias != 'solarpack'" class="file is-success" style="padding-top: 1.25em;">
                      <b-upload v-model="file" class="w-full file-label" :multiple="false" drag-drop :accept="accept">
                        <div class="w-full text-center font-bold">
                          <p>{{$t('add_new_file')}} <b>+</b></p>
                        </div>
                      </b-upload>
                    </b-field>

                    <!-- campo oculto subir fichero version -->
                    <b-field v-if="true" class="file is-success">
                      <b-upload v-model="fileVersion" id="fileVersionInput" v-show="false" class="file-label" :multiple="false" drag-drop :accept="accept">
                        <div class="w-full text-center text-grey">
                          <p>{{$t('add_version')}} +</p>
                        </div>
                      </b-upload>
                    </b-field>

                    <div v-if="isLoading" class="my-4 text-center">
                      <scale-loader />
                    </div>
                  </div>


                </div>


              </form>
            </div>

      </div>

      <div v-show="editorPDF">
        <div id="webviewer" ref="webviewer" class="flex flex-col w-full h-full" style="height:90vh"></div>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import EventBus from "~/plugins/bus";
import api from '~/api';
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import WebViewer from "@pdftron/webviewer";
import Uppy from '@uppy/core'
// import AwsS3Multipart from '@uppy/aws-s3-multipart'
import AwsS3 from '@uppy/aws-s3';
import store from "~/store";
import CodificationLean from '·/components/documents-codifications/codification-lean'
import CodificationDragados from '·/components/documents-codifications/codification-dragados.vue';
import CodificationDefault from '·/components/documents-codifications/codification-default.vue';
import CodificationRejas from '·/components/documents-codifications/codification-rejas.vue';
import microsoft365 from '~/plugins/microsoft365';

export default {
  name: "validation-completion-modal",

  components: {
    ScaleLoader,
    WebViewer,
    CodificationLean,
    CodificationDragados,
    CodificationRejas,
    CodificationDefault,
  },

  props: {
    flowId: { type: Number, required: true },
    validableName: { type: String, required: true },
    validableParentCode: { type: String, required: false, default: '' },
  },

  data: () => ({
    conditionals: {},
    isModalActive: false,
    openCollapse: false,
    canCancel: ['escape', 'x', 'outside'],
    id: null,
    isLoading: false,
    showUpload: true, // ya siempre desplegado
    showCodification: false,
    desc_name: '', // contendrá un nombre descriptivio auxiliar (campo document.name)
    custom_name: '', // contendrá el nombre fichero codificado lean 5s digital (campo document.original_filename)
    coded_name: 0,

    task: {}, // los datos de la task
    taskLineId: null, // los datos de la task

    statuses: ['started', 'pending', 'pending_validation', 'refused', 'completed'],

    form: {
      observation: null,
      status: 0,
      selectedGroup: null,
      isFirstGroup: false, // flag, grupo que va a validar esta tarea es el primero (propietario) y no podrá rechazarla
      isLastGroup: false, // flag, grupo que va a validar esta tarea es el ultimo de la linea de validacion (para disparar acciones en backend)
      isPreservingGroups: false, // flag, si se deben preservar los grupos validados al rechazar grupos pasados
    },
    fileEditing: false, // flag que indica si hay algun fichero en edicion
    file: {}, // el fichero actual seleccionado (de 1 en 1 para poder codificar)
    fileVersion: { documentId: 0}, // el fichero actual seleccionado DE NUEVA VERSION
    newVersionDocId: 0, // contendrá el document id del fichero que hay que versionar
    newVersionDescName: '', // contendrá el name del fichero que hay que versionar
    newVersionCustomName: '', // contendrá el custom_name del fichero que hay que versionar
    newFiles: [], // cola de ficheros con nombre codificado (o no) listos para subir when submit
    oldFiles: [], // lista de ficheros de la tarea subidos previamente
    editorPDF: false, // flag mostrar editor PDFTron
    iframeId: null, // id del iframe donde PDFTron se ha montado
    accept: "", // on created()
    userSignatures: '', // firmas generadas en pdftron guardadas en otras ocasiones
    uppy: null, // instancia de la libreria para subir archivos
    keyFileUploadCurrent: null, // key del archivo que se esta subiendo actualmente
    preserveValidatedGroups: false, // si se deben preservar los grupos validados al rechazar grupos pasados
    cloneDocs: false, // para verificar si el grupo actual tiene permisos para clonar documentos
    cloneDocsQuantity: {}, // cantidad de documentos a clonar, indexado por document_id
    editingFileNameIndex: null, // índice del archivo cuyo nombre se está editando
    editingFileNameValue: '', // valor temporal del nombre mientras se edita
    activityDocuments: [], // documentos de la actividad para seleccionar. Solo rejas.
    selectedActivityDoc: null, // documento seleccionado del selector documentos de actividad. Solo rejas.
    isLoadingActivityDocs: false, // loading state para documentos de actividad
    rejectPartial: false, // (validar con comentario) que es lo mismo que reject pero sin cambiar estado task a rechazado 
    oneDriveVersionFiles: {}, // archivos editados en OneDrive pendientes de reemplazar (no visibles en UI)

    isRejasProject: false, // flag para activar feature unica del proyecto rejas (vincular documentos que estan en la actividad, en la carpeta del flujo)
  }),

  mounted() {
    this.addMessageHandler(); // para pdftron
    this.isRejasProject = [893, 220].includes(this.project.id); // 893 rejas, 220 para tests
  },

  created() {

    this.accept = this.$acceptedExtensions // extensiones aceptadas

    this.uppy = new Uppy({
        debug: process.env.NODE_ENV === 'development', // activamos debug para development
        autoProceed: false,
        allowMultipleUploads: false,
      })
      .use(AwsS3, {
        shouldUseMultipart: true,
        limit: 3,
        companionUrl: '/api/v2/',
        endpoint: '/api/v2/',
        headers: {
          'Authorization': "Bearer " + store.getters["auth/token"]
        }
      })
      // .on('upload-success', (file, response) => { this.onUploadSuccess(file, response) } )
      .on('upload-success', (file, response) => { // callback deveulto cuando el file ha sido subido correctamente
        console.log('%cEPC-TACKER: '+ '%c file ' + file.data.name + ' subido correctamente', 'background: #5577BB; color: #fff', 'color: #000')
      })
      .on('upload-progress', (file, progesss) => { // callback devuelto con el progreso de subido del archivo
        this.uploadPercentage = parseInt(
          Math.round((progesss.bytesUploaded * 100) / progesss.bytesTotal)
        );
      })
      .on('upload-error', (file, error, response) => { // callback devuelto si ha ocurrido algun error en la subida
        console.error('%cEPC-TACKER: '+ '%c ha ocurrido un error al subir el archivo ' + file.data.name, 'background: #5577BB; color: #fff', 'color: #000', error)
      })
  },

  beforeDestroy(){
    this.removeMessageHanlder(); // para pdftron
  },

  computed: {
    ...mapGetters({
      company: 'app/company',
      project: 'app/project',
      user: "auth/user",
    }),

    filesSelected() {
      return this.newFiles.length > 0 || Object.keys(this.oneDriveVersionFiles).length > 0;
    },

  },

  watch: {
    // detecta cuando se selecciona un fichero en el input oculto de subir version fichero
    fileVersion: function () {
      // si seleccionado nuevo fichero para subir version
      if (this.fileVersion.name && this.fileVersion.name.length > 0) {


        this.fileVersion.documentId = this.newVersionDocId // le añade el atributo documentId que indica actualizacion de version
        this.fileVersion.desc_name = this.newVersionDescName
        this.fileVersion.custom_name = this.getNextVersionFileName(this.newVersionCustomName)
        this.fileVersion.custom_name = this.fileVersion.custom_name.substr(0, this.fileVersion.custom_name.lastIndexOf(".")) + this.getFileExtension(this.fileVersion)

        // hemos forzado a todo fichero a pasar por getNextVersion porque dentro se detectará si encuentra version o no
        // this.fileVersion.custom_name = this.newVersionHasCodedName
        //   ? this.getNextVersionFileName(this.newVersionCustomName)
        //   : this.newVersionCustomName
        this.fileVersion.has_coded_name = this.newVersionHasCodedName
        this.newVersionDocId = 0
        this.newVersionDescName = ''
        this.newVersionCustomName = ''
        this.newVersionHasCodedName = false
        this.fileEditing = true
      } else {
        this.fileEditing = false
      }
    },

    file: function () {
      if (Object.keys(this.file).length === 0 && this.file.constructor === Object)
        this.fileEditing = false // si file es objecto vacio, no hay fichero editandose
      else
        this.fileEditing = true
    },

    showCodification: function () {
      // cada vez que se oculte este form, resetear valores
      if ( this.showCodification == false) {
        this.desc_name = ''
        this.custom_name = ''
        this.coded_name = 0
        this.form = this.defaultFormValues();
      }
    },

    openCollapse: function () {
      if (this.openCollapse === false && this.rejectPartial) {
        this.rejectPartial = false
      }
    },

  },

  methods: {

    toggleUpload() {

      this.showUpload = !this.showUpload

      if (this.showUpload) {
        this.getOldFiles()
      }
    },

    async getOldFiles() {

      let self = this;

      let params = { }

      self.isLoading = true;
      let fileType = '-' //todos
      //traer los ficheros de esta task
      await axios.get("/api/v2/validations/task/"+ this.task.id + "/documents?" + fileType + "=1",
        { params: params })
        .then(function(response) {

          if (response.data && response.data.documents) {
            self.oldFiles = response.data.documents;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(function () {
          self.isLoading = false;
        });
    },

    // Solo proyecto rejas. Solo primer grupo de tarea. Devuelve documentos de la actividad que hay en la carpeta donde apunta el flujo (o carpeta raiz actividad si carpeta es null)
    async getActivityDocuments() {
      this.isLoadingActivityDocs = true;
      this.activityDocuments = [];
      this.selectedActivityDoc = null;

      try {
        // Obtener validable_id (activity_id) y folder_id del flujo de validación
        const data = await api.fetchEntity('validation', this.flowId);
        if (!data || !data.success || !data.data) return;

        const activityId = data.data.validable_id;
        const folderId = data.data.folder_id;

        // Obtener documentos de la actividad
        const response = await axios.get('/api/v2/activity/' + activityId + '/documents', {
          params: {
            '-': 1,
            order_field: 'name',
            order_dir: 'asc',
            with_folders: 1,
            folder_id: folderId
          }
        });

        if (response.data && response.data.documents) {
          this.activityDocuments = response.data.documents;
        }
      } catch (error) {
        console.log('#n4ffu error: ' + error);
      } finally {
        this.isLoadingActivityDocs = false;
      }
    },

    toggleCodification() {
      this.showCodification=!this.showCodification;
    },

    // envia un fichero recien seleccionado a la cola para subir cuando submit form
    sendToQueue(isVersion=0) {

      if (isVersion) {
        this.newFiles.push(this.fileVersion)
        this.fileVersion = { documentId: 0 }
      } else {
        this.newFiles.push(this.file)
        this.file = {}
      }

      this.showCodification=false
    },


    // aplica al campo custom_name el codigo de nombre generado desde componente hijo de codificacion
    applyFileName(obj) {

      // si estamos trabajando con un fichero a subir nuevo
      if (this.file.size) {
        this.file.desc_name = obj.desc_name ? obj.desc_name : '' // quitamos extension en el nombre descriptivo
        this.file.custom_name = obj.custom_name + this.getFileExtension(this.file)
        this.file.coded_name = obj.coded_name
      }
      // si estamos trabajando con subir una version de un fichero existente
      if (this.fileVersion.size) {
        this.fileVersion.desc_name = obj.desc_name ? obj.desc_name : '' // quitamos extension en el nombre descriptivo
        this.fileVersion.custom_name = obj.custom_name + this.getFileExtension(this.fileVersion)
        this.fileVersion.coded_name = obj.coded_name
      }

      this.toggleCodification(); // y oculta la codificacion tras acabar

    },

    // ejecuta el click del input oculto para subir fichero de version
    uploadVersion(doc) {
      this.showCodification=false // por si estaba abierto...

      this.newVersionDocId = doc.document_id
      this.newVersionDescName = doc.name2
      this.newVersionCustomName = doc.name
      this.newVersionHasCodedName = doc.coded_name
      document.getElementById('fileVersionInput').click()
    },

    
    getNextVersionFileName(fileName, forceDef = false) {

      if (!this.project.codification_form) {
        return fileName
      }

      if (this.project.codification_form.startsWith('lean')) {
        return this.getNextVersionLean(fileName, forceDef)
      }

      if (this.project.codification_form === 'rejas') {
        return this.getNextVersionRejas(fileName)
      }

      // El resto de codificaciones no hace nada
      return fileName
    },

    // lean: version en penultimo segmento separado por '_' (V00, V01... o DEF)
    // devuelve el nombre fichero sumando 1 al numero de version (si es DEF lo deja igual)
    // lo hace si nombre fich tiene 3 o mas partes separadas por '_' y en la penultima parte encuentra un numero (o V00, V01...)
    // si es asi suponemos que el nombre ha sido codificado (aunque coded_name sea 0, para cubrir casos cuando se codificó fuera de esta app)
    getNextVersionLean(fileName, forceDef = false) {
      let splitName = fileName.split('_')

      if (splitName.length < 3) {
        return fileName // fichero no codificado o con menos campos de los debidos... no hacer nada
      }

      let version = splitName[splitName.length - 2] // version siempre es el penultimo

      if (version == 'DEF') {
        return fileName // ya era DEF, no se suma nada
      }

      // El ultimo grupo, si VALIDA, se fuerza version a DEFinitivo
      if (forceDef) {
        splitName[splitName.length - 2] = 'DEF'
      } else {
        version = version.replace('V', '').replace('0', '') // V02 -> 2
        if ( isNaN(parseInt(version)) ) {
          return fileName // no se detecta numero en este campo debe ser otra cosa, devolvemos tal cual
        }
        version = parseInt(version) + 1 // 3
        splitName[splitName.length - 2] = 'V' + version.toString().padStart(2, '0') // V03
      }

      return splitName.join('_')
    },

    // rejas: version en ultimo segmento separado por '-', formato -R{letra} (RA, RB, RC...)
    // busca el patron -R{letra} al final del nombre (antes de la extension si la hay)
    // y lo incrementa a la siguiente letra del abecedario (RA -> RB, RB -> RC...)
    getNextVersionRejas(fileName) {
      const regex = /-R([A-Z])(?=\.[^.]+$|$)/
      const match = fileName.match(regex)

      if (!match) {
        return fileName // no se detecta patron de revision, devolvemos tal cual
      }

      const currentLetter = match[1]
      if (currentLetter === 'Z') {
        return fileName // ya es la ultima letra, no se puede incrementar
      }

      const nextLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1)
      return fileName.replace(regex, '-R' + nextLetter)
    },

    submitStatus(status) {
      this.form.status = status
      this.submitForm()
    },

    toggleRejectPartial(){
      this.openCollapse = !this.openCollapse
      this.rejectPartial = true
    },

    /**
     * Envía el formulario de validacion de tarea
     */
    async submitForm() {

      if (!this.task.id) { // si pulsas 20 veces el boton validar, entra alguna llamada por ahi sin task.id (veridico!)
        return;
      }
      this.canCancel = false
      let url = "/api/v2/validations/task/" + this.task.id + "/status"

      // Check if any file exceeds 4GB or is 0 bytes
      if (this.filesSelected && this.newFiles.length > 0) {
        const maxSizeBytes = 4 * 1024 * 1024 * 1024; // 4GB
        const invalid = this.newFiles.find((f) => {
          const size = Number(f.size);
          return size <= 0 || size > maxSizeBytes;
        });
        if (invalid) {
          this.isLoading = false;
          this.$notify.warning(
            Number(invalid.size) <= 0 ? "document_corrupt_cero_size" : "document_exceeded_max_size",
            { name: invalid.name }
          );
          return false;
        }
      }

      this.isLoading = true;

      await axios({
        method: "post",
        url: url,
        data: this.form,
        })
        .then((response) => {
          this.taskLineId = response.data[0].id;
          this.$toast.open({
            message: response.data.error || this.$t("success_editing"),
            type: response.data.error ? "is-danger" : "is-success",
            position: "is-top-right",
          });
          EventBus.$emit("refreshValidationTasks");
        })
        .catch((error) => {
          //Se produjo un error
          this.isLoading = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("update_error"),
            type: "is-danger",
            position: "is-top-right",
          });
        });

      await this.linkActivityDocuments();

      if (this.filesSelected) {
        await this.uploadFiles();
      } else {
        this.isLoading = false;
      }

      EventBus.$emit("refreshValidationDocumentsNotifications");
      // this.$emit("reload-documents");
      this.hide();
      // this.$emit("reload");
      // notificamos flujo completado (projectRules)
      await axios.get('/api/v2/validation/' + this.flowId + '/callback')
    },

    async uploadFiles() {
      // Procesar archivos de OneDrive por separado (no añadir a newFiles para evitar que aparezcan en UI)
      const oneDriveFiles = Object.values(this.oneDriveVersionFiles)
      this.oneDriveVersionFiles = {} // Limpiar inmediatamente

      if (this.newFiles.length == 0 && oneDriveFiles.length == 0) {
        return;
      }

      this.isLoading = true;

      // Primero subir archivos de OneDrive (versiones de documentos existentes)
      for (const oneDriveFile of oneDriveFiles) {
        if (oneDriveFile.size > 0) {
          let ok = await this.submitFile(oneDriveFile);
          if (!ok) {
            this.isLoading = false;
            this.$notify.error("upload_document_error");
            return false;
          }
        }
      }

      // Luego subir archivos normales de newFiles
      let files = this.newFiles.slice();
      for (var i = files.length - 1; i >= 0; i--) {
        let ok = await this.submitFile(files[i]);
        if (ok) {
          this.newFiles.splice(i, 1);
          this.$notify.success("upload_document_success", {
            files: files[i].name,
          });
        } else {
          this.isLoading = false;
          this.$notify.error("upload_document_error");
          this.$buefy.dialog.alert({
            title: 'Error',
            message: 'El fichero '+files[i].name+' no se ha podido subir, por favor intentelo de nuevo',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          return false;
        }
      }

      // Todos los ficheros subidos
      this.isLoading = false;
      const totalFiles = files.length + oneDriveFiles.length;
      if (totalFiles > 0) {
        this.$notify.success("upload_document_success", {
          files: totalFiles,
        });
      }
      this.$emit("refreshValidationDocumentsNotifications");
      return true;
    },

    async submitFile(file) {

      this.uploadPercentage = 0;
      this.cancelRequest = axios.CancelToken.source();

      // si el ultimo validador está VALIDANDO (aceptando) la tarea
      // se fuerza a DEF las nuevas versiones subidas
      if (this.form.isLastGroup &&
        this.form.status == 3 &&
        file.has_coded_name &&
        file.custom_name) {
          file.custom_name = this.getNextVersionFileName(file.custom_name, true)
      }

      let form = new FormData();

      // file.name no se puede escribir, usamos file.new_name
      // si escribió un nombre descriptivo, usamos ese, si no el nombre por defecto del fichero
      file.new_name = file.desc_name || file.name

      // campo obligatorio en api, 'original_filename'
      if (file.custom_name) {
        form.append("original_filename", file.custom_name.trim())
      } else {
        form.append("original_filename", file.new_name.trim())
      }

      // si hay coded_name = 1 es porque se ha metido el nombre a traves de form de codificacion
      if (file.coded_name) {
        form.append("coded_name", 1) // si viene de subir version, tendrá definido has_coded_name
      }

      // campo opcional en api, 'file_name' con nombre descriptivo
      if (file.desc_name) {
        form.append("file_name", file.new_name.trim())
      }
      //else en backend se calcula este campo a partir de original_filename si no se introduce nada


      return this.store(file, {})
        .then(async result => {
            // successFul contiene toda la lista de archivos que se han subido
            // para nuestro caso solo consideramos siempre el primero por que enviamos de a uno
            if( result.successful.length > 0 ) {
              let response = result.successful[0].response

              let params = {
                // uuid: response.uuid,
                key: response.body.key,
                // bucket: response.bucket,
                // name: file.name,
                content_type: file.type,
                // url: response.url
              }

              form.append("aws_response", JSON.stringify(params));

              let endpoint = ''
              if(file.documentId && file.documentId > 0) {
                // addversion
                form.append("validation_task_line_id", this.taskLineId);
                form.append("validation_task_id", this.task.id);

                form.append("entity_type", "validation"); // subir version no vincula a validationtask, solo modifica el document existente, debe llevar 'validation'
                form.append("entity_id", this.flowId);

                endpoint = '/api/v2/document/' + file.documentId + '/add_version/validation/' + this.flowId
              } else {
                // fichero nuevo
                form.append("entity_type", "validationtask");
                form.append("entity_id", this.task.id);
                form.append("project_id", this.project.id)
                endpoint = "/api/v2/validation" + "/" + this.flowId + "/document"
              }

              let resp = null
              resp = await axios.post(endpoint, form, {
                cancelToken: this.cancelRequest.token,
              })

              return resp && resp.data && resp.data.success ? resp.data.success : false
            }

            // failed contiene todos los archivos que tuvieron fallo al subir
            if (result.failed.length > 0) {
              console.error('Errors:')
              result.failed.forEach((file) => {
                console.error(file.error)
              })

              return false
            }
        }).catch((error) => {
          console.log('fail #ff44b: ',error)
          return false;
        })

    },

    // CUSTOM VAPOR STORE METHOD
    async store(file, options = null) {

      // verificamos si existe algun archivo en la lista de carga de uppy
      // si existe lo eliminamos
      if( this.keyFileUploadCurrent ) {
        this.uppy.removeFile(this.keyFileUploadCurrent);
      }

      this.keyFileUploadCurrent = this.uppy.addFile({
        name: file.name, // file name
        type: file.type, // file type
        data: file, // file blob
        // meta: {
        //   // optional, store the directory path of a file so Uppy can tell identical files in different directories apart.
        //   relativePath: webkitFileSystemEntry.relativePath,
        // },
        source: 'Local',
        isRemote: false,
      });

      return this.uppy.upload()

    },

    // metodo especial solo para rejas. Vincula a la tarea un documento ya existente en la actividad del flujo
    async linkActivityDocuments() {
      // si no hay doc seleccionado, no hacer nada
      if (!this.selectedActivityDoc) return;

      let form = new FormData();

      form.append("task_id", this.task.id);
      form.append("document_id", this.selectedActivityDoc.document_id)
      form.append("line_id", this.taskLineId)

      try {
        const resp = await axios.post("/api/v2/validation/" + this.flowId + "/link-activity-document", form)

        if (resp.data && resp.data.success) {
          this.selectedActivityDoc = null
          return true
        } else {
          this.$toast.open({ message: resp.data.msg || this.$t('update_error'), type: 'is-danger', position: 'is-top-right', })
          return false
        }
      } catch (error) {
        const msg = error.response && error.response.data && error.response.data.msg
          ? error.response.data.msg
          : this.$t('update_error')
        this.$toast.open({ message: msg, type: 'is-danger', position: 'is-top-right', })
        return false
      }
    },

    // quita el fichero del cuadro de "edicion"
    removeFile(isVersion) {
      this.showCodification = false

      if (isVersion) {
        this.fileVersion = { documentId: 0 }
      } else {
        this.file = {}
      }

      this.showCodification=false
    },


    /**
     * Muestra este modal
     */
    show(task, isFirstGroup, isLastGroup, preserveValidatedGroups = false) {
      this.getSignatures(); // aqui en show trae firmas nuevas cada vez que edita. En created solo cada vez que recarge. Evaluar...
      this.conditionals = null;
      this.task = task;

      this.form.isFirstGroup = isFirstGroup // deshabilita boton rechazar al 1er grupo
      this.form.isLastGroup = isLastGroup
      this.preserveValidatedGroups = preserveValidatedGroups

      if(task.conditionals){
        this.conditionals = JSON.parse(task.conditionals);
      }

      this.cloneDocs = this.canCloneDocuments(task);

      this.getOldFiles()

      if (this.isRejasProject && this.form.isFirstGroup) {
        this.getActivityDocuments()
      }

      this.isModalActive = true;
    },

    /**
     * Verifica si se pueden clonar documentos en el grupo actual
     */
    canCloneDocuments(task) {
      if (!task || !task.current_group || !task.validation_groups || !Array.isArray(task.validation_groups)) {
        return false;
      }

      const currentValidationGroup = task.validation_groups.find(
        validationGroup => validationGroup.id === task.current_group.id
      );

      if (!currentValidationGroup) {
        const foundGroup = task.validation_groups.find(
          validationGroup => validationGroup.group && validationGroup.group.id === task.current_group.group_id
        );

        if (foundGroup && foundGroup.group) {
          return foundGroup.group.clone_docs === 1;
        }
        return false;
      }
      return currentValidationGroup.group && currentValidationGroup.group.clone_docs === 1;
    },

    async cloneDoc(docTemplate) {
      const qty = this.cloneDocsQuantity[docTemplate.document_id] || 0
      if (!qty || qty <= 0) {
        this.$toast.open({
          message: this.$t('specify_quantity'),
          type: "is-warning",
          position: "is-top-right",
        });
        return;
      }

      this.isLoading = true;
      this.$notify.success("starting_clone_document");

      try {
        let url = "/api/v2/document/" + docTemplate.document_id;
        const urlResponse = await axios.get(url);

        if (!urlResponse.data || !urlResponse.data.data) {
          this.$notify.error("error_download_document");
          this.isLoading = false;
          return;
        }

        //Descargar el documento como blob desde la URL temporal
        const documentUrl = urlResponse.data.data;
        const fetchResponse = await fetch(documentUrl);

        if (!fetchResponse.ok) {
          this.$notify.error("error_download_document");
          this.isLoading = false;
          return;
        }

        const blobData = await fetchResponse.blob();

        if (!blobData || blobData.size === 0) {
          this.$notify.error("error_download_document");
          this.isLoading = false;
          return;
        }
        // Obtener el tipo MIME del documento
        const fileType = fetchResponse.headers.get('content-type') || 'application/pdf';

        // Crear múltiples copias del documento
        for (let i = 0; i < qty; i++) {
          // Crear un nuevo Blob a partir del blob descargado
          const clonedBlob = new Blob([blobData], { type: fileType });

          // Crear un File a partir del Blob para que tenga todas las propiedades necesarias
          const clonedFile = new File(
            [clonedBlob],
            docTemplate.name, // nombre original
            { type: fileType }
          );

          // Agregar las propiedades necesarias para newFiles
          clonedFile.desc_name = ''; // nombre descriptivo
          clonedFile.custom_name = docTemplate.name; // nombre codificado (si aplica)
          clonedFile.coded_name = docTemplate.coded_name || 0; // flag si tiene nombre codificado

          // Agregar directamente a la cola de documentos pendientes
          this.newFiles.push(clonedFile);
        }
        // Resetear la cantidad de este documento
        this.$set(this.cloneDocsQuantity, docTemplate.document_id, 0);

      } catch (error) {
        console.error('Error cloning document:', error);
      } finally {
        this.isLoading = false;
      }
    },

    // Método auxiliar para obtener la extensión del nombre del archivo
    getFileExtensionFromName(fileName) {
      if (!fileName) return '';
      const re = /(?:\.([^.]+))?$/;
      const match = re.exec(fileName);
      return match && match[1] ? '.' + match[1] : '';
    },

    // Métodos para editar el nombre del archivo (custom_name)
    editFileName(index) {
      const file = this.newFiles[index];
      this.editingFileNameIndex = index;
      this.editingFileNameValue = file.custom_name || '';

      // Enfocar el input después de que Vue lo renderice
      this.$nextTick(() => {
        const inputs = this.$refs.fileNameInput;
        if (inputs && inputs.length > 0 && inputs[index]) {
          const inputElement = inputs[index].$el.querySelector('input');
          if (inputElement) {
            inputElement.focus();
          }
        }
      });
    },

    saveFileName(index) {
      if (this.editingFileNameIndex !== index) return;

      const newName = this.editingFileNameValue.trim();
      if (newName) {
        const file = this.newFiles[index];

        // Obtener la extensión original del custom_name
        const originalExtension = this.getFileExtensionFromName(file.custom_name);

        // Si el nuevo nombre no tiene extensión, agregar la original
        // Si tiene extensión diferente, reemplazarla por la original
        let finalName = newName;
        const newNameExtension = this.getFileExtensionFromName(newName);

        if (!newNameExtension) {
          // No tiene extensión, agregar la original
          finalName = newName + originalExtension;
        } else if (newNameExtension !== originalExtension) {
          // Tiene extensión diferente, reemplazar por la original
          const nameWithoutExtension = newName.substring(0, newName.lastIndexOf('.'));
          finalName = nameWithoutExtension + originalExtension;
        }
        file.custom_name = finalName;
      }

      this.cancelEditFileName();
    },

    cancelEditFileName() {
      this.editingFileNameIndex = null;
      this.editingFileNameValue = '';
    },

    removeNewFile(index) {
      // Si el archivo que se está editando es el que se elimina, cancelar la edición
      if (this.editingFileNameIndex === index) {
        this.cancelEditFileName();
      } else if (this.editingFileNameIndex !== null && this.editingFileNameIndex > index) {
        // Si se elimina un archivo antes del que se está editando, ajustar el índice
        this.editingFileNameIndex--;
      }
      this.newFiles.splice(index, 1);
    },

    getFileExtension(file) {
      let re = /(?:\.([^.]+))?$/;
      return "." + re.exec(file.name)[1];
    },

    emptyFile() {
      // ver si objeto fichero a subir está vacio, y tampoco se esta editando nueva version de fichero
      return Object.keys(this.file).length === 0 && this.file.constructor === Object
        &&
        this.fileVersion.documentId == 0;
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    /**
     * valores por defecto del formulario
     */
    defaultFormValues() {
      return {
        observation: null,
        status: 0,
        selectedGroup: null,
        isFirstGroup: this.form.isFirstGroup, // igual que estaba, este no se toca, se recibe en el show
        isLastGroup: this.form.isLastGroup // igual que estaba, este no se toca, se recibe en el show
      };
    },

    /**
     * Oculta este modal
     */
    hide() {
      this.task = {};
      this.canCancel = ['escape', 'x', 'outside']
      this.isModalActive = false;
      this.form = this.defaultFormValues();
      //resetamos archivos
      this.file = {}
      this.newFiles = []
      this.oldFiles = []
      this.oneDriveVersionFiles = {} // limpiar archivos editados en OneDrive
      this.activityDocuments = []
      this.selectedActivityDoc = null
      this.editorPDF = false
      this.iframeId = null
      this.openCollapse = false
      this.rejectPartial = false
      // cancelar edición de nombre si está activa
      this.cancelEditFileName()
      // this.showUpload = false
    },



    /*
    * Acción de tarea condicional
    */
    async conditionalAction(actionType, actionData, question, answer)
    {

      this.isLoading = true;

      // Preparamos los datos para pasarlos al endpoint
      let params = {
        "type" : actionType,
        "data" : JSON.stringify(actionData) ?? null,
        "task_id" : this.task.id,
        "question": question,
        "answer": answer
      }

      // Enviamos los parametros para registrar la respuesta
      await axios.post("/api/v2/validation/"+ this.flowId +"/conditional", params)
      .then((response) => {

        // Si la acción es otra condicional, renderizamos la nueva pregunta
        if(actionType == 'next_conditional'){
          this.conditionals = JSON.parse(response.data[0]);
          this.isLoading = false;

        }else{

          // Si la acción es finalizar flujo o nueva tarea, cerramos la modal y refrescamos.
          this.isLoading = false;
          EventBus.$emit("refreshValidationTasks");
          this.hide();

        }



      })
      .catch((error) => {
        this.$notify.error(error);
              this.isLoading = false;

      });

    },


    // devuelve si 'name' es una version slugged de original_filename
    differentNames(original_filename, name) {
      // en el modelo Document el name es un slug de original_filename
      let sluggedName = original_filename.toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');

      return sluggedName != name
    },


    async downloadDoc(doc) {
      this.$notify.success("starting_download_document");
      let url = "/api/v2/document/" + doc.document_id;

      const {data} = await axios.get(url);

      if (data) {
        // window.open(doc.file.raw); // podria ahorrar la llamada a GET /document porque aqui tenemos la ruta directa a bucket, pero mejor usamos api para que devuelva la descarga con el nombre original del fichero
        window.open(data.data);
      } else {
        this.$notify.error("error_download_document");
      }
    },


    // *********** PDFTRON ***************

    editPDF(file, isVersionOfDocId = 0) {
      this.editorPDF = true
      this.file4editor = file

      if (this.iframeId) {
        // ya hay instancia de pdftron creada, tan solo cambiar el documento editado
        this.sendMessage(this.iframeId, isVersionOfDocId)
      } else {
        // PDFTron no ha sido cargado todavia, crear instancia
        this.loadPdftron(isVersionOfDocId)
      }
    },


    // addMessageHandler: function() {
    async addMessageHandler() {
      let self = this;

      // escuchará los mensajes enviados desde /pdftron_config.js
      window.addEventListener('message', self.handleAddMessage);
    },

    handleAddMessage(event) {
      let self = this;
      // recibido mensaje con id del iframe creado por Webviewer
      if (event.data.type=='viewerReady') {

        // en produccion: assets en cloudfront.net, distinto al dominio *.epc-tracker.com, limitaciones protocolarias no recibe id iframe
        // Si no recibe id de iframe, detectarlo aqui, será el primer nodo hijo del div 'webviewer'
        self.iframeId = event.data.data || document.getElementById("webviewer").childNodes[0].id

        let isVersionOfDocId = event.data.isVersionOfDocId || 0

        // enviamos mensaje a ese iframe con el documento a mostrar
        self.sendMessage(self.iframeId, isVersionOfDocId) // id del iframe que crea Webviewer para mostrarse
      }

      // recibido mensaje con el documento ya editado que hay que guardar
      if (event.data.type=='saveDocument') {

        // flag distinguir si subir version o crear nuevo desde plantilla
        if (event.data.isVersionOfDocId) {
          // nueva version
          event.data.data.documentId = event.data.isVersionOfDocId
          event.data.data.name = self.file4editor.name // mantiene nombre igual
        } else {
          // subir nuevo desde plantilla. Generar nombre fichero: nombrefich+nombreactividad
          event.data.data.name = self.genFileNamePDF()
        }

        self.newFiles.push(event.data.data)
        self.editorPDF = false // volvemos a validar/rechazar
        self.file4editor = {}

        // self.submitFile(event.data.data) // Blob del fichero editado. Guardado directo funciona OK
        //   .then(ok => {
        //     if (ok) {
        //       self.$notify.success("upload_document_success", event.data.data.name)
        //       self.editorPDF = false // volvemos a validar/rechazar
        //       self.file4editor = {}
        //       self.getOldFiles() // reload files
        //     }
        //   })
      }

      // recibido mensaje con las firmas del usuario a guardar
      if (event.data.type=='saveSignatures') {
        // guardar firmas en DB (firmas vienen serializadas. Son trazos si son dibujos y base64 si son imagenes)
        self.saveSignatures(event.data.data)
      }
    },


    removeMessageHanlder: function(){
      window.removeEventListener('message', this.handleAddMessage);
    },


    // envia postMessage que será recogido en /pdftron_config.js
    sendMessage(frameId='webviewer-1', isVersionOfDocId = 0) {
      // pasa un mensaje al iframe alojado en "otro" dominio (cloudfront.net)
      // con url del documento a cargar. Asi evitamos cors
      document.getElementById(frameId)
        .contentWindow.postMessage({
          type:'epc-document',
          data: this.file4editor,
          isVersionOfDocId: isVersionOfDocId
          }, '*')

      // establecer usuario que está editando (aparecerá su nombre al firmar)
      document.getElementById(frameId)
        .contentWindow.postMessage({ type:'epc-user', data: this.user }, '*')

      // carga en herramienta de firmas las firmas guardadas del usuario
      if (this.userSignatures.length > 0) {
        document.getElementById(frameId)
          .contentWindow.postMessage({ type:'user-signatures', data: this.userSignatures }, '*')
      }

    },


    loadPdftron(isVersionOfDocId = 0) {
      // console.log("path ", process.env.ASSET_PATH)
      // Esto creará un iframe dentro del div webviewer
      // y aparentemente estará alojado en otro dominio ya que va por la url de los assets (clouldfront.net)
      WebViewer({
        licenseKey: 'EPC TRACKER DEVELOPMENTS S L:OEM:EPC Tracker::B+:AMS(20260330):62B5F2D30477A80A4360B13AC9A2D57860612FDDEBC3AD8846C78E53BF875C0791C6B6F5C7',
        path: `${process.env.ASSET_PATH}webviewer`,
        config: `${process.env.ASSET_PATH}pdftron_config.js`,
        custom: JSON.stringify({ validationTaskForm: true, isVersionOfDocId: isVersionOfDocId }),
      }, this.$refs.webviewer)
        .then(instance => {
          // todo el codigo está en el fichero de pdftron_config.js pasado arriba
          // para que pueda ser ejecutado en produccion donde el dominio (app/dev).epc-tracker.com
          // será distinto que los asset (*.cloudfront.net)
          // asi se evita los problemas de cors porque ese fichero pdftron_config.js se ejecuta en el mismo dominio que webviewer
          // para ello hemos insertado los dominios en whitelisted in public/pdftron_configorigin.txt
        })


    },


    async getSignatures() {

      let self = this;

      const {data} = await axios.get('/api/v2/user/' + this.user.id + '/pdf-signatures')
      if (data && data.success) {
        self.userSignatures = data.data?.signatures || ''
      } else {
        console.log("Could not load user PDFSignatures")
      }

    },


    async saveSignatures(signatures) {

      const {data} = await axios.post('/api/v2/user/' + this.user.id + '/pdf-signatures', { signatures })
      if (data && data.success) {
        // do nothing. silently saved
      } else {
        this.$notify.error(data.msg)
      }

    },


    // cuando generamos un fichero a partir de documento de proyecto, el nombre será: nombrefich+nombreactividad
    genFileNamePDF() {
      return this.file4editor.name.replace(/\.[^/.]+$/, "") // nombre fich sin extension
        + '_'
        + this.validableName.trim().toLowerCase().replaceAll(' ', '_') // nombre actividad sin espacios
        + this.getFileExtension(this.file4editor) // extension fich
    },


    // *********** MICROSOFT 365 INTEGRATION ***************

    // Método que decide qué editor usar según el tipo de archivo
    openOnlineEditor(file, documentId = 0) {
      if (microsoft365.isOfficeFile(file)) {
        this.openWithMicrosoft365(file, documentId)
      } else {
        this.editPDF(file, documentId)
      }
    },

    // Abre el documento en Microsoft 365 para edición online (flujo validaciones)
    // NO guarda directamente en S3, guarda el archivo en memoria (invisible)
    // El archivo reemplazará al original cuando el usuario ejecute Validar/Validar con comentario
    openWithMicrosoft365(file, documentId) {
      // Abrir popup SINCRÓNICAMENTE en el click del usuario.
      // Chrome bloquea window.open() con features si no viene de un click nativo del DOM.
      const editorWindow = microsoft365.openEditorPopup()
      if (!editorWindow) {
        this.$buefy.dialog.alert({
          title: this.$t('microsoft365.popup_blocked_title'),
          message: this.$t('microsoft365.popup_blocked_message'),
          type: 'is-warning'
        })
        return
      }
      microsoft365.openWithMicrosoft365ForValidation(
        { document_id: documentId, name: file.name },
        editorWindow,
        (downloadedFile) => {
          // Guardar el archivo en memoria (NO visible en UI)
          // Se usará para reemplazar el documento original al validar
          downloadedFile.documentId = documentId
          this.$set(this.oneDriveVersionFiles, documentId, downloadedFile)
        },
        this
      )
    },


  },
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
  appearance: textfield; /* Standard */
}
</style>
